import { Auth } from "aws-amplify";
import { browserHistory } from "react-router";
import StarBorderIcon from "@material-ui/icons/StarBorder";
import StarIcon from "@material-ui/icons/Star";
import axios from "axios";
import { api_url, token } from "./constantInformation";
import { TaskQueue } from "cwait";
import React from "react";
import { CancelOutlined, LockOpenOutlined } from "@material-ui/icons";
import { LockIcon } from "./icons";
import { auth, getToken, getUserIDToken, googleProvider, remoteConfig, waitForAuthInit } from "../firebase";
import { isEmailInUserGroup } from "../firestoreQueries";
import { sportsConfig } from "./sportsConfig";

const currentYear = new Date().getFullYear();
const MAX_SIMULTANEOUS_CALLS = 18;
const availablePlatforms = ["DREAM11"];
export const getStatsForSport = (sport) => {
  return sportsConfig[sport];
};

const player_responsibility_mapping = [
  {
    menu_name: "Player (1x FP)",
    display_name: "P",
    full_name: "General",
    description:
      "The Dream11 Fantasy Points Projection for the player in general",
  },
  {
    menu_name: "Vice Captain (1.5x FP)",
    display_name: "VC",
    full_name: "Vice Captain",
    description:
      "The Dream11 Fantasy Points Projection for the player if chosen vice captian (1.5x)",
  },
  {
    menu_name: "Captain (2x FP)",
    display_name: "C",
    full_name: "Captain",
    description:
      "The Dream11 Fantasy Points Projection for the player if chosen captian (2x)",
  },
];
const isProduction = true;
const featureDomain = "fantasyipl-feature.auth.ap-south-1.amazoncognito.com";
const productionDomain = "fantasyipl-dev.auth.ap-south-1.amazoncognito.com";

const PROFILE_AVATAR_API_URL =
  "https://ui-avatars.com/api/?background=1d1d1d&color=ffffff&rounded=true&name=";

const availableLeaguesCricket = ["WPL", "PSL", "BPL"];
const availableLeaguesKabaddi = ["PKL"];
const leagues2023 = ["BBL", "SUPER-SMASH-MEN", "SUPER-SMASH-WOMEN", "PKL"];
const sportsWithLeagues = {
  CRICKET: availableLeaguesCricket,
  KABADDI: availableLeaguesKabaddi,
  // Add more sports and their leagues
};

const availableUserPlatformLeagues = Object.fromEntries(
  availablePlatforms.map((item) => [item.toLowerCase(), sportsWithLeagues])
);

// console.log(
//   "Available user platform Leagues::: ",
//   availableUserPlatformLeagues
// );
const getProfileAvatarForName = (name) => {
  return PROFILE_AVATAR_API_URL + name;
};

const getAssetsPublicPath = (path) => {
  // console.log("Public path", window.location.origin);
  return window.location.origin + "/" + path;
};
function getNameToDisplay(email) {
  return email.split("@")[0];
}

const capitalize = (s) => (s && s[0].toUpperCase() + s.slice(1)) || "";

function findSportByLeague(targetLeague, rcConfig = null, callingFrom = "") {
  var rc;
  if (process.env.REACT_APP_ENV === "production") {
    rc =
      JSON.parse(rcConfig?.config?.globalAvailableSportsAndLeagues?._value) ||
      JSON.parse(remoteConfig.defaultConfig.globalAvailableSportsAndLeagues._value);
    // console.log("Remote Config", rc);
  } else {
    rc =
      JSON.parse(rcConfig?.config?.availableSportsAndLeaguesTesting?._value) ||
      JSON.parse(
        remoteConfig.defaultConfig.availableSportsAndLeaguesTesting._value
      );
  }
  // temporary putting dream11 as platform to parse remoteConfig for now
  //TODO: update this later
  const sports =
    rc.platforms.find((platform) => platform.name.toLowerCase() === "dream11")
      ?.sports || [];

  // find sport which has the league
  for (const sport of sports) {
    // console.log("Sport", sport, targetLeague);
    for (const league of sport.leagues) {
      // console.log("League--", league, targetLeague);
      if (league === null) {
        // alert("League is null", sport, targetLeague);
      }
      if (targetLeague === null) {
        // alert(
        //   "targetLeague is null -- calling from",
        //   callingFrom,
        //   sport,
        //   targetLeague
        // );
      }
      if (league.name.toLowerCase() === targetLeague.toLowerCase()) {
        // console.log("League found in sports", targetLeague, sport);
        return capitalize(sport.name);
      } else {
        // console.log("League not found in sports", targetLeague, sport);
      }
    }
  }
}

async function getUserGroup() {
  try {
    const resp = await Auth.currentAuthenticatedUser();
    const userGroup =
      resp.signInUserSession.accessToken.payload["cognito:groups"];
    console.log("UserGroup: ", userGroup);
    return userGroup;
  } catch (e) {
    console.log("exception getting user");
    console.log(e);
    return null;
  }
}
async function checkIfAdmin(email) {
  try {
    console.log("Inside checkIfAdmin");
    const resp = await isEmailInUserGroup(email);
    const docData = resp.docs.map((doc) => doc.data());
    console.log("docData:", docData);

    if (docData.length > 0 && docData[0].email === email) {
      return true;
    } else {
      return false;
    }
  } catch (error) {
    console.error("Error in checkIfAdmin:", error);
    throw error; // Rethrow the error to be caught in the outer catch block
  }
}

function checkIfBlogTeam(userGroup) {
  if (userGroup) {
    if (userGroup[0] === "blog") {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
}
async function getUserEmail() {
  try {
    const userEmail = auth.currentUser.email;
    if (userEmail !== null) {
      return userEmail;
    } else {
      console.log("User Email:: ", userEmail);
      return null;
    }
  } catch (e) {
    console.log("Error: getUserEmail, exception getting user");
    console.log(e);
    return null;
  }
}
async function getUserId() {
  try {
    const data = auth.currentUser.email;
    // const data = await Auth.currentAuthenticatedUser();
    console.log("Username: ", data);
    return data;
  } catch (e) {
    console.log("Error: getUserEmail, exception getting user");
    console.log(e);
    return null;
  }
}

async function getUserJwtToken() {
  try {
    const user = auth.currentUser || await waitForAuthInit(auth);
    if (!user) {
      return null;
    }

    const token = await user.getIdToken(true);
    console.log("User JWT: ", `Bearer ${token}`);
    return `Bearer ${token}`;
  } catch (e) {
    console.log("Error: getJwtToken, Error getting jwt token for user");
    return null;
  }
}

function isLoggedIn(path) {
  console.log("isLoggegIn Called from: ", path);
  return new Promise((resolve, reject) => {
    try {
      auth.onAuthStateChanged((user) => {
        if (user) {
          console.log("isLoggegIn auth state changed user:: " + user.email);
          resolve(true);
        } else {
          console.log("isLoggegIn auth state changed NOT user:: " + user);
          resolve(false);
        }
      });
    } catch (e) {
      console.log("isLoggegIn error in isLoggedIn:: " + e);
      reject(e);
    }
  });
}

async function signOut() {
  try {
    await auth.signOut();
    // await Auth.signOut();
    console.log("signout done without error ");
  } catch (error) {
    console.log("signout error signing out: ", error);
  }
}

async function signOutGlobal() {
  try {
    await Auth.signOut({ global: true });
  } catch (error) {
    console.log("error signing out: ", error);
  }
}

async function signUpNormal(email, password) {
  try {
    const { user } = await Auth.signIn({
      username: email,
      password,
    });
    console.log("user", user);
    return true;
  } catch (error) {
    console.log("error signing up:", error);
    return false;
  }
}

async function resendConfirmationCode(username) {
  try {
    await Auth.resendSignUp(username);
    console.log("code resent successfully");
    return true;
  } catch (err) {
    console.log("error resending code: ", err);
    return false;
  }
}

function redirectToSignin() {
  console.log("redirect to sign in called");
  browserHistory.push("/app/signin");
}

// Send confirmation code to user's email
async function forgotPassword(email) {
  const resp = await auth.sendPasswordResetEmail(email);
  return resp;
}

async function forgotPasswordSubmit(username, code, new_password) {
  const resp = Auth.forgotPasswordSubmit(username, code, new_password);
  return resp;
}

function getEndIcon(locked, favourite, excluded) {
  if (locked === false && favourite === false && excluded === false) {
    return (
      <>
        <LockOpenOutlined></LockOpenOutlined>
      </>
    );
  } else if (locked === true && favourite === false && excluded === false) {
    return (
      <>
        <LockIcon className="text-primary"></LockIcon>
      </>
    );
  } else if (locked === false && favourite === true && excluded === false) {
    return (
      <>
        <StarIcon className="text-warning"></StarIcon>
      </>
    );
  } else if (locked === false && favourite === false && excluded === true) {
    return (
      <>
        <CancelOutlined className="text-danger"></CancelOutlined>
      </>
    );
  }
}

function ratings(number) {
  // if (number == 0) {
  // console.log("Rating", number);
  if (number == 0) {
    return (
      <>
        <div className="d-flex razin justify-content-center">
          <StarBorderIcon className="align-items-center align-self-center" />
          <StarBorderIcon className="align-items-center align-self-center" />
          <StarBorderIcon className="align-items-center align-self-center" />
          <StarBorderIcon className="align-items-center align-self-center" />
          <StarBorderIcon className="align-items-center align-self-center" />
        </div>
      </>
    );
  } else if (number == 1) {
    return (
      <>
        <div className="d-flex razin justify-content-center">
          <StarIcon className="align-items-center align-self-center text-danger" />
          <StarBorderIcon className="align-items-center align-self-center" />
          <StarBorderIcon className="align-items-center align-self-center" />
          <StarBorderIcon className="align-items-center align-self-center" />
          <StarBorderIcon className="align-items-center align-self-center" />
        </div>
      </>
    );
  } else if (number == 2) {
    return (
      <>
        <div className="d-flex razin justify-content-center">
          <StarIcon className="align-items-center align-self-center" />
          <StarIcon className="align-items-center align-self-center" />
          <StarBorderIcon className="align-items-center align-self-center" />
          <StarBorderIcon className="align-items-center align-self-center" />
          <StarBorderIcon className="align-items-center align-self-center" />
        </div>
      </>
    );
  } else if (number == 3) {
    return (
      <>
        <div className="d-flex razin justify-content-center">
          <StarIcon className="align-items-center align-self-center" />
          <StarIcon className="align-items-center align-self-center" />
          <StarIcon className="align-items-center align-self-center" />
          <StarBorderIcon className="align-items-center align-self-center" />
          <StarBorderIcon className="align-items-center align-self-center" />
        </div>
      </>
    );
  } else if (number == 4) {
    return (
      <>
        <div className="d-flex razin justify-content-center">
          <StarIcon className="align-items-center align-self-center text-success" />
          <StarIcon className="align-items-center align-self-center text-success" />
          <StarIcon className="align-items-center align-self-center text-success" />
          <StarIcon className="align-items-center align-self-center text-success" />
          <StarBorderIcon className="align-items-center align-self-center" />
        </div>
      </>
    );
  } else {
    return (
      <>
        <div className="d-flex razin justify-content-center">
          <StarIcon className="align-items-center align-self-center text-success" />
          <StarIcon className="align-items-center align-self-center text-success" />
          <StarIcon className="align-items-center align-self-center text-success" />
          <StarIcon className="align-items-center align-self-center text-success" />
          <StarIcon className="align-items-center align-self-center text-success" />
        </div>
      </>
    );
  }

  // }
}
const fetchDataForPlatformAndLeague = async (platform, league) => {
  const url = api_url + "/slate/" + platform + "/" + league;
  const jwtToken = await getUserJwtToken();
  const result = await axios
    .get(url, {
      headers: {
        "Authorization": jwtToken
        // ClientID: process.env.REACT_APP_COGNITO_CLIENT_ID,
      },
    })
    .catch((error) => {
      console.error(error);
    });
  console.log("SINGLE API RESULT", result);
  return result.data;
};

const team_css_class_map = {
  RCB: "rcb",
  DC: "dc",
  KKR: "kkr",
  PBKS: "pbks",
  RR: "rr",
  SRH: "srh",
  MI: "mi",
  CSK: "csk",
  GT: "gt",
  LSG: "lsg",
};

const availableLeagues = ["SA20"];
const available_user_platform_leagues = Object.fromEntries(
  availablePlatforms.map((item) => [item.toLowerCase(), availableLeagues])
);
// console.log(
//   "Available user platform Leagues::: ",
//   available_user_platform_leagues
// );

function getCurrentPlatforms(isAdmin) {
  return availablePlatforms;
}

const available_internal_platform_leagues = Object.fromEntries(
  availablePlatforms.map((item) => [item.toLowerCase(), availableLeagues])
);

const isVisible = (id) => {
  console.log("isVisible", id);
  console.log("isVisible element", document.getElementById(id));
  let canSee = window
    .getComputedStyle(document.getElementById(id), "")
    .getPropertyValue("display");
  if (canSee === "none") {
    return false;
  } else return true;
};
async function fetchUrl(url) {
  const jwtToken = await getUserJwtToken();
  console.log("JWT Token: ", jwtToken);
  try {
    const response = await axios.get(url, { headers: { 
      "Authorization": jwtToken
     } });
    return response.data;
  } catch (error) {
    console.error(`Error fetching URL ${url}:`, error);
    return null; // Return null or a fallback value to handle errors gracefully
  }
}

async function getDataForAllPlatformLeague(platform, isAdmin, remoteConfig) {
  const sportsWithLeagues = getCurrentPlatformLeagues(
    platform,
    isAdmin,
    remoteConfig
  );
  if (!sportsWithLeagues) {
    console.error("Failed to get sports with leagues");
    return {};
  }

  let dynamicUrls = sportsWithLeagues.flatMap((sport) =>
    sport.leagues.map((league) => ({
      url: `${api_url}${sport.name.toLowerCase()}/slate/${platform.toLowerCase()}/${league.name.toUpperCase()}`,
      sport: sport.name,
      league: league.name,
    }))
  );

  console.log(
    "URLs to fetch: ",
    dynamicUrls.map((d) => d.url)
  );

  const queue = new TaskQueue(Promise, MAX_SIMULTANEOUS_CALLS);

  // Map each URL to a queued fetch operation, ensuring limited concurrency
  const fetchPromises = dynamicUrls.map(({ url, sport, league }) =>
    queue.wrap(() => fetchUrl(url).then((data) => ({ sport, league, data })))()
  );

  const results = await Promise.all(fetchPromises);

  // Organize the results by sport and league
  let finalResults = results.reduce((acc, { sport, league, data }) => {
    if (data) {
      // Ensure there's data before adding to final results
      if (!acc[sport]) acc[sport] = {};
      acc[sport][league] = data;
    }

    for (const sport in acc){
      for (const league in acc[sport]) {
        acc[sport][league].forEach(game => {
            game.slate_timeframe = convertToLocalDate(game.GameDateTime);
        });
      }
    }
    
    return acc;
  }, {});

  return finalResults;
}
// async function getDataForAllPlatformLeague(platform, isAdmin, remoteConfig) {
//   const sportsWithLeagues = getCurrentPlatformLeagues(
//     platform,
//     isAdmin,
//     remoteConfig
//   );
//   let dynamic_url = [];

//   // Iterate over each sport and its leagues to create URLs
//   sportsWithLeagues.forEach((sport) => {
//     console.log("Sport: ", sport.name, sport.leagues);
//     sport.leagues.forEach((league) => {
//       const url =
//         api_url +
//         sport.name.toLowerCase() +
//         "/slate/" +
//         platform.toLowerCase() +
//         "/" +
//         league.name.toUpperCase();
//       dynamic_url.push(url);
//     });
//   });

//   console.log("getDataForAllPlatformLeague URLs: ", dynamic_url);

//   const MAX_SIMULTANEOUS_CALL = 18;
//   const queue = new TaskQueue(Promise, MAX_SIMULTANEOUS_CALL);

//   // Fetch data concurrently for all URLs
//   const results = await Promise.all(
//     dynamic_url.map(
//       queue.wrap(
//         async (url) =>
//           await axios
//             .get(url, {
//               headers: {  },
//             })
//             .catch((error) => {
//               console.error(error);
//             })
//       )
//     )
//   );

//   console.log("Concurrent Results: ", results);

//   // Organize the results by sport and league
//   let final = {};
//   let resultIndex = 0;
//   sportsWithLeagues.forEach((sport) => {
//     final[sport.name] = {};
//     sport.leagues.forEach((league) => {
//       final[sport.name][league.name] = results[resultIndex++]["data"];
//     });
//   });
//   return final;
// }

// async function getDataForAllPlatformLeague(platform, isAdmin) {
//   const jwtToken = await getUserJwtToken();
//   console.log("JWT TOKEN", jwtToken);
//   let dynamic_url = [];
//   if (isAdmin) {
//     dynamic_url = availableLeaguesCricket.map((league) => api_url + "slate/" + platform.toLowerCase() + "/" + league);
//   } else {
//     dynamic_url = availableLeaguesCricket.map((league) => api_url + "slate/" + platform.toLowerCase() + "/" + league);
//   }
//   console.log("getDataForAllPlatformLeague: ", dynamic_url);

//   console.log("getDataForAllPlatformLeague: ", dynamic_url);

//   const MAX_SIMULTANEOUS_CALL = 8;

//   const queue = new TaskQueue(Promise, MAX_SIMULTANEOUS_CALL);

//   const results = await Promise.all(
//     dynamic_url.map(
//       queue.wrap(
//         async (url) =>
//           await axios
//             .get(url, {
//               headers: {
//               },
//             })
//             .catch((error) => {
//               console.error(error);
//             })
//       )
//     )
//   );

//   console.log("Concurrent Results:: ", results);
//   let final = {};
//   if (isAdmin) {
//     availableLeaguesCricket.forEach((league, index) => {
//       final[league] = results[index];
//     });
//   } else {
//     availableLeaguesCricket.forEach((league, index) => {
//       final[league] = results[index];
//     });
//   }

//   return final;
// }

const getCurrentSeasonForLeagueFromRC = (league, rcConfig) => {
  const leagueConfKey = "leagueConf";
  const rc = getConfigValue(rcConfig.config, leagueConfKey);
  log("Remote Config League Conf", rc);

  const leagueRC = rc.leagues.find(
    (leagueObject) =>
      leagueObject.leagueName.toLowerCase() === league.toLowerCase()
  );
  return leagueRC.season; //should have a safety check
};

// Utility function to abstract environment-specific configurations
const getConfigValue = (config, key) => {
  console.log("Environment:", process.env.REACT_APP_ENV);

  const isProduction = process.env.REACT_APP_ENV === "production";
  let configKey;
  if(isProduction){
    configKey = key;
  }
  else {
    if(key === "globalAvailableSportsAndLeagues") 
      configKey = "availableSportsAndLeaguesTesting";
    else 
      configKey = "leagueConfTesting";
  }
  log(`Using config key: ${configKey}`);
  return JSON.parse(config[configKey]._value);
};

// Utility function for logging, easily replaceable with a more comprehensive logging solution
const log = (message, type = "log") => {
  // Check if the specified type is a function on the console object, default to "log" if not
  const logFunction =
    console[type] && typeof console[type] === "function"
      ? console[type]
      : console.log;
  logFunction(message);
};

function getCurrentPlatformLeagues(platform, isAdmin, rcConfig = null) {
  if (!rcConfig || !rcConfig.config) {
    log("Remote Config or rcConfig.config is not defined", "error");
    return null;
  }

  try {
    const availableSportsKey = "globalAvailableSportsAndLeagues";
    const leagueConfKey = "leagueConf";

    const rc = getConfigValue(rcConfig.config, availableSportsKey);
    log("Remote Config", rc.platforms ? rc.platforms : null);
    // Add this in getConfigValue

    const leagueConfObject = getConfigValue(rcConfig.config, leagueConfKey);
    log("Remote Config League Conf", leagueConfObject);

    const matchedPlatform = rc.platforms.find(
      (pl) => platform.toLowerCase() === pl.name.toLowerCase()
    );

    if (!matchedPlatform) {
      throw new Error(`${platform} not supported currently`);
    }

    log(`Platform: ${matchedPlatform.name}`);
    log(`Platform sports:`, matchedPlatform.sports);

    // Refactored function to filter leagues based on the league configuration
    const filterLeagues = (sports) => {
      return sports
        .map((sport) => ({
          ...sport,
          leagues: sport.leagues.filter((league) =>
            leagueConfObject.leagues.some(
              (leagueObj) =>
                leagueObj.leagueName.toLowerCase() === league.name.toLowerCase()
            )
          ),
        }))
        .filter((sport) => sport.leagues.length > 0); // Further filter to exclude sports with no matching leagues
    };

    return filterLeagues(matchedPlatform.sports);
  } catch (error) {
    log(`Get Current Platform Leagues Error: ${error.message}`, "error");
    return null;
  }
}

function getLeagueDisplayName(leagueName, isAdmin, rcConfig = null) {

  if (!rcConfig || !rcConfig.config) {
    log("Remote Config or rcConfig.config is not defined", "error");
    return null;
  }

  try {
    const leagueConfKey = "leagueConf";

    const leagueConfObject = getConfigValue(rcConfig.config, leagueConfKey);

    const league = leagueConfObject.leagues.find( league =>
      league.leagueName.toLowerCase() === leagueName.toLowerCase()
    )

    const displayName = league.displayName

    return displayName;
  } catch (error) {
    return null;
  }

}

// var rc;
// if (process.env.NODE_ENV === "production") {
//   rc = JSON.parse(rcConfig.config.globalAvailableSportsAndLeagues._value);
// } else {
//   rc = JSON.parse(rcConfig.config.availableSportsAndLeaguesTesting._value);
// }
// console.log("Remote Config", rc.platforms ? rc.platforms : null);

// var leagueConfObject;
// if (process.env.NODE_ENV === "production") {
//   leagueConfObject = JSON.parse(rcConfig.config.leagueConf._value);
// } else {
//   leagueConfObject = JSON.parse(rcConfig.config.leagueConfTesting._value);
// }
// console.log("Remote Config League Conf", leagueConfObject);

// let matchedPlatformSports = null; // Default to null if not found
// try {
//   const matchedPlatform = rc.platforms.find(
//     (pl) => platform.toLowerCase() === pl.name.toLowerCase()
//   );
//   if (matchedPlatform) {
//     console.log("platform:: ", matchedPlatform.name, platform);
//     console.log("platform sports:: ", matchedPlatform.sports, platform);
//     matchedPlatformSports = matchedPlatform.sports; // Assign the sports if found
//   } else {
//     throw new Error(platform + " not supported currently"); // Throw an error if not found
//   }
// } catch (e) {
//   console.error("Get Current Platform Leagues", e.message); // Log the error message
// }
// //modify matchedPlatformSports such that it contains leagues that are present in leagueConfObject

// if (matchedPlatformSports) {
//   matchedPlatformSports.forEach((sport) => {
//     sport.leagues = sport.leagues.filter((league) => {
//       return leagueConfObject.leagues.find(
//         (leagueObj) =>
//           leagueObj.leagueName.toLowerCase() === league.name.toLowerCase()
//       );
//     });
//   });
// }
// return matchedPlatformSports; // Return the sports array or null if not found
// }

function convertToLocalDate(isoString) {
  const date = new Date(isoString);  // Convert ISO string to Date object
  const day = date.getDate().toString().padStart(2, '0'); // Get the day and pad with leading zero if necessary
  const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Get the month, add 1 (since months are 0-indexed), and pad
  const year = date.getFullYear(); // Get the full year
  return `${year}-${month}-${day}`; // Format to DD-MM-YYYY
}

const current_gamelogs_leagues = {
  dream11: ["WC"],
};

export {
  player_responsibility_mapping,
  isLoggedIn,
  signUpNormal,
  signOut,
  signOutGlobal,
  resendConfirmationCode,
  redirectToSignin,
  forgotPassword,
  forgotPasswordSubmit,
  getUserEmail,
  getNameToDisplay,
  ratings,
  isProduction,
  featureDomain,
  productionDomain,
  team_css_class_map,
  getUserGroup,
  checkIfAdmin,
  getCurrentPlatformLeagues,
  getDataForAllPlatformLeague,
  getUserJwtToken,
  isVisible,
  getEndIcon,
  getUserId,
  getAssetsPublicPath,
  fetchDataForPlatformAndLeague,
  getProfileAvatarForName,
  checkIfBlogTeam,
  currentYear,
  leagues2023,
  availableLeaguesCricket,
  availableLeaguesKabaddi,
  sportsWithLeagues,
  findSportByLeague,
  current_gamelogs_leagues,
  getCurrentSeasonForLeagueFromRC,
  capitalize,
  getLeagueDisplayName,
  convertToLocalDate,
};
